import {Component} from "@angular/core";
import {AdminResultCaseService} from "../../case.service";
import {ViewManagerService} from "../../../../services/view-manager.service";

@Component({
  selector: "admin-results-case-form",
  templateUrl: "./form.component.html",
  styleUrls: ["./form.component.css"]
})
export class AdminResultsCaseFormComponent {

  constructor(
    private caseService: AdminResultCaseService,
    private viewManager: ViewManagerService
  ) {
  }

  get query() {
    return this.caseService.query;
  }

  reset(){
    this.caseService.reset()
  }

  search(){
    this.caseService.search()
  }

}
